import React from "react";
import { Grid } from "@mui/material";
import { startCase } from "lodash";
import LabeledText from "../../Widgets/LabeledText";
import { DevelopmentalHistoryFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: DevelopmentalHistoryFormValues;
}

const addMonthsLabel = (value: number | null) =>
  value != null ? `${value} month${value !== 1 ? "s" : ""}` : "-";

const formatEnum = (value: string | null | undefined): string =>
  value ? startCase(value.toLowerCase()) : "-";

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="When did the client's development start to seem different from other children?"
        value={formValues.whenDevelopmentSeemedDifferent}
      />
      <LabeledText
        label="Complications during pregnancy or immediately after birth"
        value={formValues.complicationsPregnancyBirth}
      />
      <LabeledText
        label="Age (in months) when the client began crawling"
        value={addMonthsLabel(formValues.ageBeganCrawlingMonths)}
      />
      <LabeledText
        label="Age (in months) when the client began walking"
        value={addMonthsLabel(formValues.ageBeganWalkingMonths)}
      />
      <LabeledText
        label="Age (in months) when the client began speaking"
        value={addMonthsLabel(formValues.ageBeganSpeakingMonths)}
      />
      <LabeledText
        label="Did the caregiver report the child being irritable or easygoing in infancy/early childhood?"
        value={formatEnum(formValues.childTemperament)}
      />
      <LabeledText
        label="Was the child interested in being held in infancy/early childhood?"
        value={formatEnum(formValues.interestedInBeingHeld)}
      />
      <LabeledText
        label="Was the child interested in being played with in infancy/early childhood?"
        value={formatEnum(formValues.interestedInBeingPlayedWith)}
      />
      <LabeledText
        label="Was the child's caregiver able to attend to the child's needs?"
        value={formatEnum(formValues.caregiverAttendedToNeeds)}
      />
      <LabeledText
        label="Additional notes related to the client's infancy/early childhood"
        value={formValues.additionalNotesInfancyChildhood}
      />
    </Grid>
  );
};

export default ViewFields;
